<template>
    <div>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>

        <v-container>
            <v-form ref="form">
                <v-row>
                    <h2 class="pb-5 pl-7">{{ this.parentObject.pageTitle }}<span class="page_title_value pl-1">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <v-row>
                    <div class="pt-2 pl-7 pb-5">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 70px;"
                            @click="backHandler" 
                            > 
                             {{$t('button.back') }}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>
                
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5 ml-n1"
                >

                    <div>
                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.exercisecode')"
                                    ref="reviewcode"
                                    readonly
                                    v-model="formData.reviewcode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="8" sm="8" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.exercisedesc')"
                                    ref="description"
                                    readonly
                                    v-model="formData.description"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodstartdate')"
                                    ref="startdate"
                                    type="date"
                                    readonly
                                    v-model="formData.startdate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodenddate')"
                                    ref="enddate"
                                    type="date"
                                    readonly
                                    v-model="formData.enddate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.assessmenttype')"
                                    ref="assessmentcode"
                                    readonly
                                    v-model="formData.assessmentcode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="2" sm="2" class="mt-n6 mb-4">
                                <v-text-field
                                    class="big-field"
                                    outlined
                                    :label="$t('pmreviewexercise.recordsgenerated')"
                                    ref="totalRecords"
                                    readonly
                                    v-model="formData.totalRecords"
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>

                <v-container>
                    <div>
                        <v-row>
                            <app-table
                                v-bind:parentObject = "{
                                    tabHeader: this.filteredTabHeader,
                                    detailItem: this.staffList,
                                    isWizard: this.parentObject.isWizard,
                                    pageTitle: this.parentObject.pageTitle,
                                    pageTitleValue: this.parentObject.pageTitleValue,
                                }"
                            />
                        </v-row>
                    </div>
                </v-container>

                <v-row>
                    <div class="pt-5 pl-7">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 100px; margin-bottom: 20px;"
                            @click="closeHandler" 
                            > 
                            {{$t('button.close')}}
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row>

            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTableStaff';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
       'app-table': CRUDTable,
        "app-error": ErrorDialog,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },

            formData: {
                id: this.parentObject.data.pmreviewexerciseid,
                pmreviewexerciseid: this.parentObject.data.pmreviewexerciseid,
                reviewcode: this.parentObject.data.reviewcode,
                description: this.parentObject.data.description,
                assessmentid: this.parentObject.data.assessmentid,
                assessmentcode: this.parentObject.data.assessmentcode,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                roleid: this.parentObject.data.roleid,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid,
                totalRecords: this.parentObject.data.totalRecords,
            },

            formDataParameter: this.$route.params.formDataParameter,
            parameters: this.$route.params.parameters,      
            staffList: this.parentObject.staffList,   

            errMsg: "",
            isErr: false,


            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.staffcode'), value: 'staffcode', width: '200px', sortable: true},
                { text: this.$t('columns.name'), value: 'staffname', width: '200px', sortable: true},
                { text: this.$t('columns.startdate'), value: 'startdate', width: '200px', sortable: true},
                { text: this.$t('columns.enddate'), value: 'enddate', width: '200px', sortable: true},
                { text: this.$t('columns.company'), value: 'compnycode', width: '200px', sortable: true},
                { text: this.$t('columns.branch'), value: 'brchcode', width: '200px', sortable: true},
                { text: this.$t('columns.department'), value: 'deptcode', width: '200px', sortable: true},
                { text: this.$t('columns.section'), value: 'sectiocode', width: '200px', sortable: true},
                { text: this.$t('columns.unit'), value: 'unitcode', width: '200px', sortable: true},
                { text: this.$t('columns.grade'), value: 'grdcode', width: '200px', sortable: true},
                { text: this.$t('columns.position'), value: 'poscode', width: '200px', sortable: true},
            ],
        }
    },

    computed: {
        filteredTabHeader() {
            if (this.parentObject.isWizard) {
                return this.tabHeader.filter(item => item.value !== 'action');
            } else {
                return this.tabHeader;
            }
        },

        totalRecord() {
            return this.staffList.length;
        }
    },

    methods: {

        closeHandler() {
            this.$router.push({name: 'reviewexerciselist'});
        },

        backHandler(){
            this.$router.push({name: 'reviewexercisegenerate', params: { formData: this.formData, formDataParameter: this.formDataParameter, parameters: this.parameters}});
        },

    },
}
</script>
